export default __webpack_public_path__ + "static/media/icon-visa-24px.756df345.svg";